import React from 'react';

import { FineDetails, OrderSummaryText } from '../style';

type TotalItemProps = {
    item: string;
    amount: string;
};
export default function TotalItem({ item, amount }: TotalItemProps) {
    return (
        <>
            <FineDetails>
                <OrderSummaryText>{item}</OrderSummaryText>
                <OrderSummaryText>{amount}</OrderSummaryText>
            </FineDetails>
        </>
    );
}
